exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desktop-navigation{position:relative;text-align:center}.desktop-navigation.no-scroll{width:calc(100% - 17px)}.desktop-navigation.no-scroll-safari{width:calc(100% - 15px)}.desktop-navigation__wrap{display:inline-block;vertical-align:top;position:static;width:auto;height:100%;background-color:rgba(0,0,0,0);-webkit-box-shadow:none;box-shadow:none}.desktop-navigation__wrap a{display:inline-block;height:100%;vertical-align:top;margin-right:40px;margin-bottom:0;padding:28px 0 26px;font-size:17px;font-weight:400;line-height:1.41;color:#909090;border-bottom:3px solid rgba(0,0,0,0);cursor:pointer}.desktop-navigation__wrap a:last-child{margin-right:0}.desktop-navigation__wrap a.active{color:#333;border-bottom:3px solid #c31b1c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/components/navigation/desktop/style.scss
// module id = 1129
// module chunks = 62